var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import { Label } from 'reactstrap';
import styles from './EditChecklistModal.module.scss';
import { Api } from '@app/Api';
import { Input } from '@app/Components/Input/Input';
import { Modal } from '@app/Components/Modal/Modal';
export var EditChecklistModal = /** @class */ (function (_super) {
    __extends(EditChecklistModal, _super);
    function EditChecklistModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EditChecklistModal.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.isOpen !== prevProps.isOpen && this.props.isOpen)
            this._postFix = this.props.postFix;
    };
    EditChecklistModal.prototype._onToggle = function () {
        this.props.onToggle();
    };
    EditChecklistModal.prototype._onSave = function () {
        return __awaiter(this, void 0, void 0, function () {
            var onChecklistEdit, checklistId;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        onChecklistEdit = (_a = this.props, _a.onChecklistEdit), checklistId = _a.checklistId;
                        return [4 /*yield*/, Api.secured.updateChecklistPostFix({ checklistId: checklistId, postFix: this._postFix })];
                    case 1:
                        _b.sent();
                        onChecklistEdit();
                        this._onToggle();
                        return [2 /*return*/];
                }
            });
        });
    };
    EditChecklistModal.prototype.render = function () {
        var _a;
        var _this = this;
        var isOpen = (_a = this.props, _a.isOpen), postFix = _a.postFix, checklistCodeName = _a.checklistCodeName;
        return (React.createElement(Modal, { isOpen: isOpen, toggle: this._onToggle, headerTitle: "Edit PostFix on ".concat(checklistCodeName), minWidth: "40%", footerbuttons: this._getFooterButtons },
            React.createElement("div", { className: styles.line },
                React.createElement("div", { className: styles.field },
                    React.createElement(Label, null, "Checklist PostFix"),
                    React.createElement(Input, { type: "text", defaultValue: postFix, maxLength: 3, onChange: function (e) { return (_this._postFix = e.target.value); } })))));
    };
    Object.defineProperty(EditChecklistModal.prototype, "_getFooterButtons", {
        get: function () {
            return [
                {
                    color: 'success',
                    onClick: this._onSave,
                    disabled: this._postFix === this.props.postFix,
                    title: 'Save'
                },
                {
                    onClick: this._onToggle,
                    title: 'Close'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        observable
    ], EditChecklistModal.prototype, "_postFix", void 0);
    __decorate([
        action.bound
    ], EditChecklistModal.prototype, "_onToggle", null);
    __decorate([
        action.bound
    ], EditChecklistModal.prototype, "_onSave", null);
    __decorate([
        computed
    ], EditChecklistModal.prototype, "_getFooterButtons", null);
    EditChecklistModal = __decorate([
        observer
    ], EditChecklistModal);
    return EditChecklistModal;
}(React.PureComponent));
